import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../field.interface';
@Component({
  selector: 'c4dweb-textarea',
  template: `

<ng-container *ngIf="group != null">
    <mat-form-field class='demo-full-width'  [formGroup]='group'>
    <textarea matInput [formControlName]='field.name' [placeholder]='field.label' [type]='field.inputType'></textarea>
    <ng-container *ngFor='let validation of field.validations;' ngProjectAs='mat-error'>
    <mat-error *ngIf='!group.get(field.name).hasError(validation.name)'>{{validation.message}}</mat-error>
    </ng-container>
    </mat-form-field>
</ng-container>

<ng-container *ngIf="group == null">
    <mat-form-field class='demo-full-width'>
    <textarea matInput [placeholder]='field.label.toUpperCase()' [type]='field.inputType'></textarea>
    <ng-container *ngFor='let validation of field.validations;' ngProjectAs='mat-error'>
    <mat-error *ngIf='!group.get(field.name).hasError(validation.name)'>{{validation.message}}</mat-error>
    </ng-container>
    </mat-form-field>
</ng-container>
`,
  styles: []
})
export class C4dWebTextAreaComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor() { }
  ngOnInit(): void { }
}
